import { render, staticRenderFns } from "./TabUnloading.vue?vue&type=template&id=3697e4bc"
import script from "./TabUnloading.vue?vue&type=script&lang=js"
export * from "./TabUnloading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports